import { render, staticRenderFns } from "./invoke.vue?vue&type=template&id=32455936&scoped=true&"
import script from "./invoke.vue?vue&type=script&lang=js&"
export * from "./invoke.vue?vue&type=script&lang=js&"
import style0 from "./invoke.vue?vue&type=style&index=0&id=32455936&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32455936",
  null
  
)

export default component.exports